<template lang="html">
  <div v-bind:id="id">
    <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation" :id="id">
  <div class="navbar-brand">
    <a class="navbar-item" href="/">
      <img v-if="!isDark" :src="safeClientConfig.logo?.img || safeClientConfig.squareLogo?.img" />
      
      <img v-if="isDark" :src="safeClientConfig.logo?.darkImg || safeClientConfig.squareLogo?.darkImg || safeClientConfig.logo?.img" />
    </a>
  </div>
    </nav>

    <div class="card" style="margin: 10% auto; max-width: 450px; width: 90%;">
  <div class="card-content">
    <div class="media">
      <div class="media-content has-text-centered" style="margin-bottom: 1.5rem;">
        <span v-html="safeClientConfig.title"></span>
      </div>
    </div>

    <div class="content is-flex is-flex-direction-column is-align-items-center" style="gap: 1rem; width: 100%;">
      
      <button v-for="b of safeClientConfig.buttons" 
        :key="b.process" 
        @click="login(b.process)"
        class="button is-rounded is-fullwidth is-flex is-justify-content-center is-align-items-center custom-login-btn"
        style="max-width: 300px; height: 50px; padding: 0 1.25rem; font-weight: 600;">
        
        <div v-if="b.img" class="icon-wrapper">
          <img :src="b.img" :alt="b.label || b.process" />
        </div>

        <span>{{ b.label || b.process }}</span>

      </button>

      </div>
    </div>
  </div>

  </div>

</template>

<script>

export default {
  name: 'bulmaLogin',
  components: {},
  computed: {
    config() {
      const obj = this.$store.getters.getObject(this.id);
      return obj ? obj.data : {}; 
    },
    clientConfig() {
      return this.$clientConfig ? this.$clientConfig.loginPage : null;
    },
    safeClientConfig() {
      return this.clientConfig || {};
    },
    safeConfig() {
      return this.config || {};
    },
    isDark() {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return true
      return false
    }
  },
  props: {
    id: String,
  },
  data() {
    return {}
  },
  mounted: function () {
    // Controlla se c'è un parametro di errore nell'URL
    // Gestione corretta dei parametri URL
    let params;
    
    // Combina parametri da query string e hash fragment
    const searchParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.substring(2));
    
    // Crea un nuovo URLSearchParams combinando entrambi
    params = new URLSearchParams();
    
    // Aggiungi prima i parametri dalla query string
    for (const [key, value] of searchParams) {
      params.set(key, value);
    }
    
    // Poi aggiungi i parametri dall'hash (sovrascrivendo eventuali duplicati)
    for (const [key, value] of hashParams) {
      params.set(key, value);
    }
    
    const retPath = params.get('retPath');
    const logout = params.get('logout');
    if (retPath === 'NotFound') {
      this.errorMessage = 'Utente non autorizzato.\n riprova a fare il login.';
    }
    if (logout === '1') {
      this.errorMessage = "Logout effettuato. Effettua nuovamente l'accesso.";
    }
  },
  async created() {},
  methods: {
    async login(process) {
      console.log('login', process);
      // TODO so in some way when i click button i need to know what provider i used? or do i rewrite it to usertype
      if(process == 'microsoft') {
        let OBJECT_WITH_GOOGLE_LINK_TO_REDIRECT = await this.$store.dispatch('ssologin');
        console.log('url:', OBJECT_WITH_GOOGLE_LINK_TO_REDIRECT.data);
        
        window.location.href=OBJECT_WITH_GOOGLE_LINK_TO_REDIRECT.data;
      }
      if(process == 'google') {
        let OBJECT_WITH_GOOGLE_LINK_TO_REDIRECT = await this.$store.dispatch('signInWithProvider', { provider: "google", callBackPath:"/"});
        console.log('url:', OBJECT_WITH_GOOGLE_LINK_TO_REDIRECT.authorizationUrl);
        let url =  OBJECT_WITH_GOOGLE_LINK_TO_REDIRECT.authorizationUrl
  
        window.location.href=url;
      }
    },
    manageModal: async function(b) {
      console.log('manageModal', b);
      if (b==1 || b==-1) {
        this.test_validate();
      }  
      if (b==0) {
        await this.test_login();
      }
    },

    test_validate: async function() {
      console.log('test_validate');
      let x=await this.$store.dispatch('validate_login');
      console.log(x);
    },

    test_login: async function() {
      console.log('test_login');
      
      let email='ptorric@gnet.it';
      let myid_token='12345';
      let res=await this.$store.dispatch('login', { email: email, myid_token: myid_token } )
      if (res!=true && res!=false) {
        console.log('redirect!');
        console.log(res);
        window.location.href=res;
      }
    },
  }
}
</script>

<style scoped>
.custom-login-btn {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  color: #374151;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.custom-login-btn:hover {
  background-color: #f9fafb;
  border-color: #d1d5db;
  color: #111827;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: 12px;
  flex-shrink: 0;
}

.icon-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

:deep(.is-dark) .custom-login-btn,
.is-dark .custom-login-btn {
  background-color: #1f2937;
  border-color: #374151;
  color: #f9fafb;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
}

:deep(.is-dark) .custom-login-btn:hover,
.is-dark .custom-login-btn:hover {
  background-color: #374151;
  border-color: #4b5563;
  color: #ffffff;
}

@media (prefers-color-scheme: dark) {
  .custom-login-btn {
    background-color: #1f2937;
    border-color: #374151;
    color: #f9fafb;
  }
  
  .custom-login-btn:hover {
    background-color: #374151;
    border-color: #4b5563;
  }
}
</style>
